import { supabase } from '../../lib/supabase';
import type { LeaseApplication } from '../../types/lease-application';

export async function getLeaseApplications() {
  const { data, error } = await supabase
    .from('lease_applications')
    .select('*')
    .order('app_date', { ascending: false });

  if (error) {
    throw new Error(`Error fetching lease applications: ${error.message}`);
  }

  return data as LeaseApplication[];
}

export async function getLeaseApplicationById(id: number) {
  const { data, error } = await supabase
    .from('lease_applications')
    .select('*')
    .eq('app_id', id)
    .single();

  if (error) {
    throw new Error(`Error fetching lease application: ${error.message}`);
  }

  return data as LeaseApplication;
}

export async function createLeaseApplication(application: Omit<LeaseApplication, 'app_id'>) {
  const { data, error } = await supabase
    .from('lease_applications')
    .insert([application])
    .select()
    .single();

  if (error) {
    throw new Error(`Error creating lease application: ${error.message}`);
  }

  return data as LeaseApplication;
}

export async function updateLeaseApplication(
  id: number,
  updates: Partial<Omit<LeaseApplication, 'app_id'>>
) {
  const { data, error } = await supabase
    .from('lease_applications')
    .update(updates)
    .eq('app_id', id)
    .select()
    .single();

  if (error) {
    throw new Error(`Error updating lease application: ${error.message}`);
  }

  return data as LeaseApplication;
}

export async function deleteLeaseApplication(id: number) {
  const { error } = await supabase
    .from('lease_applications')
    .delete()
    .eq('app_id', id);

  if (error) {
    throw new Error(`Error deleting lease application: ${error.message}`);
  }
}
